// extracted by mini-css-extract-plugin
export default {"LocationsView":"LocationsView_LocationsView__YXW0K"};